import { render, staticRenderFns } from "./SalesPeriod.vue?vue&type=template&id=3e8f54a4&scoped=true&"
import script from "./SalesPeriod.vue?vue&type=script&lang=ts&"
export * from "./SalesPeriod.vue?vue&type=script&lang=ts&"
import style0 from "./SalesPeriod.vue?vue&type=style&index=0&id=3e8f54a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8f54a4",
  null
  
)

export default component.exports